import React from 'react'

import { withStyles } from 'pmt-ui/styles'
import Typography from 'pmt-ui/Typography'

import ComponentList from './ComponentList'

const styles = theme => ({
  app: {
    width: '100%',
    padding: theme.spacing(4),
  },
  section: {
    width: '100%',
    marginBottom: theme.spacing(8),
  },
  title: {
    textAlign: 'left',
    paddingBottom: theme.spacing(1),
    marginBottom: theme.spacing(4),
    borderBottom: `1px solid ${theme.pmt.colors.grey500}`,
  },
})

class SectionList extends React.Component {
  generateSection(sectionList) {
    const { classes } = this.props

    return sectionList.map((section, index) => (
      <div key={index} className={classes.section}>
        <Typography variant="h6" className={classes.title}>
          {section.title}
        </Typography>
        <ComponentList
          list={section.getComponents ? section.getComponents() : section.components}
        />
      </div>
    ))
  }

  render() {
    const { list, classes } = this.props

    return <div className={classes.sectionList}>{this.generateSection(list)}</div>
  }
}

export default withStyles(styles)(SectionList)
